import React from "react";
import { useLang } from "../context/LangContext";
import { useSettings } from "../context/SettingsContext";
import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const { lang, t } = useLang();
  const { settings } = useSettings();
  return (
    <footer
      className="mt-24 pt-16 pb-8 px-6 md:px-12"
      style={{ background: "var(--primary)", color: "var(--primary-fg)" }}
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: "var(--primary-fg)", color: "var(--primary)" }}>
              <Leaf size={18} />
            </span>
            <span className="font-serif text-2xl">
              {lang === "mn" ? settings.site_title_mn : settings.site_title_en}
            </span>
          </div>
          <p className="opacity-80 leading-relaxed max-w-md">
            {lang === "mn" ? settings.tagline_mn : settings.tagline_en}
          </p>
        </div>
        <div>
          <div className="uppercase tracking-widest text-xs opacity-60 mb-3">{t("nav_home")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="opacity-80 hover:opacity-100">{t("nav_home")}</Link></li>
            <li><Link to="/gallery" className="opacity-80 hover:opacity-100">{t("nav_gallery")}</Link></li>
            <li><Link to="/booking" className="opacity-80 hover:opacity-100">{t("nav_booking")}</Link></li>
            <li><Link to="/contact" className="opacity-80 hover:opacity-100">{t("nav_contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="uppercase tracking-widest text-xs opacity-60 mb-3">{t("contact_title")}</div>
          <ul className="space-y-2 text-sm">
            {settings.contact_phone && (
              <li className="flex items-center gap-2"><Phone size={14} /> {settings.contact_phone}</li>
            )}
            {settings.contact_email && (
              <li className="flex items-center gap-2"><Mail size={14} /> {settings.contact_email}</li>
            )}
            <li className="flex items-center gap-2">
              <MapPin size={14} /> {lang === "mn" ? settings.contact_address_mn : settings.contact_address_en}
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/10 text-xs opacity-60 flex flex-wrap justify-between gap-2">
        <span>© {new Date().getFullYear()} Minimodu Eco Camping</span>
        <span>Made with care in the pines</span>
      </div>
    </footer>
  );
}
